<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
@import '~bootstrap';
@import '~bootstrap-vue';
@import './styles/main.scss';
</style>
